import { Accordion, AccordionDetails, AccordionSummary, makeStyles, Theme } from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";

const useStyles = makeStyles((theme: Theme) => ({
  accordion: {
    '&.Mui-expanded': {
      margin: 0,
    },
    '&::before': {
      display: 'none',
    },
    borderBottom: 'solid 0.5px',
  },
  category: {
    borderRadius: '6px 6px 6px 6px',
    flex: '1 0 0',
    minHeight: '35px !important',
    cursor: 'pointer',
    userSelect: 'text',
    '& .MuiAccordionSummary-content': {
      margin: '0',
    },
    '& .MuiAccordionSummary-root': {
      minHeight: '35px !important',
    },
    '&.Mui-expanded': {
      borderRadius: '6px 6px 0px 0px',
    },
    padding: '0',
  },
}));

export const PayoffCardAccordionRow = observer(({ isOpen = true, expandAll = undefined, collapseAll = undefined, children }) => {
  const classes = useStyles();

  const [open, setOpen] = useState(isOpen);

  useEffect(() => {
    if (expandAll) {
      setOpen(true);
    }
  }, [expandAll]);

  useEffect(() => {
    if (collapseAll) {
      setOpen(false);
    }
  }, [collapseAll]);

  return (
    <Accordion elevation={0} expanded={open} className={classes.accordion}>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        className={classes.category}
        onClick={() => setOpen(prev => !prev)}
      >
        {children[0]}
      </AccordionSummary>
      <AccordionDetails style={{ padding: '0', display: 'inline' }}>
        {children[1]}
      </AccordionDetails>
    </Accordion>
  );
});